import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { RootState } from "app/store";

const rawBaseQuery = (path: string) =>
  fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/api/${path}`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth?.central.api_token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  });

export const baseQueryWithAuth = (path: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =>
  async (args, api, extraOptions) => {
    const result = await rawBaseQuery(path)(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
      localStorage.removeItem("auth");
      window.location.href = "/login";
    }

    return result;
  };
